import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToDecimalPipe } from './decimal-pipe/decimal.pipe';
import { ToMoneyPipe } from './money-pipe/money.pipe';

@NgModule({
  imports: [DecimalPipe, ToDecimalPipe, ToMoneyPipe],
  providers: [DecimalPipe, ToDecimalPipe, ToMoneyPipe],
  declarations: [],
  exports: []
})
export class NumericPipesModule {}
